/* eslint-disable max-len */
import axios from "axios";
import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import { Col, Row } from "../../components/StyledGridSystem";
import { UserContext } from "../../context/UserContext";
import styled from "styled-components";
import { StyledTableCell, StyledTableRow } from "../../components/Table";
import TableComponent from "../../components/Table";
import { TableBody, TableHead, TableRow } from "@mui/material";
import LoadingSpinner from "../../components/LoadingSpinner";
import { SemesterContext } from "../../context/SemesterContext";
import ConfirmModal from "../../components/ConfirmModal";
import SnackBar from "../../components/SnackBar";
import CreditsDropdown from "../../components/CreditsDropdown";
import moment from "moment";
import { FlexGrow } from "../../components/FlexBox";
import { StyledText, TextSize } from "../../components/Text";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import EvaluateModal from "./EvaluateModal";
import ViewDetailModal from "./ViewDetailModal";
import Icon from "../../components/Icon";
import { handleJWTError } from "../../hooks/jwtErrHandler";
const CustomRow = styled(Row)`
  margin-bottom: 0px;
  height: calc(100vh - 84px);
  height: -moz-calc(100vh - 84px);
  height: -o-calc(100vh - 84px);
  height: -webkit-calc(100vh - 84px);
`;
type Card = {
  assessed_skills: number;
  competency_code: string;
  credits: number;
  id: string;
  mastery_level: number;
  mastery_level_title: string;
  required: boolean;
  status: string;
  title: string;
  total_skills: number;
  transferred: boolean;
  action: any;
  detail: any;
  // is_cross_version?: any;
  provides_credit?: boolean;

};
interface Column {
  id:
  | "competency_code"
  | "title"
  | "credits"
  | "status"
  | "total_skills"
  | "assessed_skills"
  | "mastery_level_title"
  | "action"
  // | "is_cross_version"
  | "provides_credit"
  | "detail";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "competency_code", label: "Competency Code", minWidth: 100 },
  { id: "title", label: "Competency Title", minWidth: 200 },
  {
    id: "credits",
    label: "Credits",
    minWidth: 80,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "status",
    label: "Status",
    minWidth: 80,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "total_skills",
    label: "Number of Skills",
    minWidth: 100,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "assessed_skills",
    label: "Number Assessed",
    minWidth: 100,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "provides_credit",
    label: "Provides Credit",
    minWidth: 10,
  },
  {
    id: "mastery_level_title",
    label: "Mastery Level",
    minWidth: 100,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "detail",
    label: "",
    minWidth: 10,
    // format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "action",
    label: "",
    minWidth: 10,
    // format: (value: number) => value.toLocaleString("en-US"),
  },
];
function StudentCreditsPage({
  globalSnackCount = 0,
}: {
  globalSnackCount?: number;
}) {
  const screenClass = useScreenClass();
  const [credits, setCredits] = useState<Array<Card>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [confirm, setConfirm] = useState<boolean>(false);
  const [confirmExtend, setConfirmExtend] = useState<boolean>(false);
  const [isNoNextSemesterOpen, setIsNoNextSemesterOpen] =
    useState<boolean>(false);
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  // const [confirmArchive, setConfirmArchive] = useState<boolean>(false);
  const [isMessageOpen, setIsMessageOpen] = useState<boolean>(false);
  const [totalCredits, setTotalCredits] = useState(0);
  const [totalRecordedCredits, setRecordedCredits] = useState(0);
  // var totalCredit = 0
  const [messageType, setMessageType] =
    useState<"error" | "success" | "warning" | "info">("error");
  const [message, setMessage] = useState<string>("");
  const [messageHeader, setMessageHeader] = useState<string>("");
  const [selectedCard, setSelectedCard] = useState<Card>();
  const [enrolled, setEnrolled] = useState<boolean>(true);
  const [isEvaluteOpen, setIsEvaluateOpen] = useState<boolean>(false);
  const [evaluationData, setEvaluationData] = useState<any>([]);
  const [isDetailOpen, setIsDetailOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [isExceedFinalAssessmentDate, setIsExceedFinalAssessmentDate] =
    useState(false);
  const userContext = useContext(UserContext);
  const currentUser = userContext.user;
  const semesterContext = useContext(SemesterContext);
  useEffect(() => {
    fetchVersion(currentUser.id);
    fetchCredits(currentUser.id);
    fetchCompetencyEvaluation();
    setIsExceedFinalAssessmentDate(
      compareTwoDates(
        new Date(),
        new Date(semesterContext.selectedSemester?.final_assess_date)
      )
    );
  }, [currentUser, semesterContext]);
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const fetchVersion = (id: string) => {
    setEnrolled(true);
    axios
      .get(
        `/student/version?student_id=${id}&semester_name=${semesterContext.selectedSemester?.label}&program_id=${userContext.user?.programs?.[0]?.id}`
      )
      .then((res) => {
        // console.log(res);
      })
      .catch((error) => {
        handleJWTError(error);
        if (
          error.response.data.error === "Student not enrolled for this semester"
        ) {
          setEnrolled(false);
        } else {
          console.log("An error occurred:", error);
        }
      });
  };
  const fetchCredits = (id: string) => {
    setLoading(true);
    axios
      .get(
        `/student/cards/semester?student_id=${id}&semester_name=${semesterContext.selectedSemester?.label}&program_name=${userContext.user?.programs?.[0]?.program_name}`
      )
      .then((res) => {
        if (res.data.card_info.cards) {
          const filteredCards = res.data.card_info.cards.filter(
            (card: any) => card.status !== "Incomplete"
          );
          setCredits(filteredCards);
          const total = filteredCards.reduce(
            (sum: number, competency: any) =>
              competency.competency_code.includes("SOF")
                ? sum
                : sum + competency.credits,
            0
          );
          const totalRecordedCredits = filteredCards.reduce(
            (sum: number, competency: any) => {
              if (
                competency.status === "Recorded" &&
                !competency.competency_code.includes("SOF")
              ) {
                return sum + competency.credits;
              }
              return sum;
            },
            0
          );
          setTotalCredits(total);
          setRecordedCredits(totalRecordedCredits);
        } else {
          setCredits([]);
          setTotalCredits(0);
          setRecordedCredits(0);
        }
        setLoading(false);
      })
      .catch((error) => {
        handleJWTError(error);
        setCredits([]);
        // setTotalCredits(0);
        // setRecordedCredits(0);
        setLoading(false);
      });
  };
  const recordCredits = () => {
    setLoading(true);
    axios
      .get(
        `/student/credit/record?student_id=${currentUser.id}&competency_card_id=${selectedCard?.id}`
      )
      .then((res) => {
        setLoading(false);
        setConfirm(false);
        setMessage(res.data.status.message);
        if (res.data.status.success === true) {
          setMessageType("success");
          setMessageHeader("Success!");
          fetchCredits(currentUser.id);
        } else {
          setMessageType("error");
          setMessageHeader("Error!");
        }
        setIsMessageOpen(true);
        setConfirm(false);
      })
      .catch(function (error) {
        handleJWTError(error);
        if (error.response) {
          setLoading(false);
          setMessage(error.response.data.error || "Something went wrong!");
          setMessageType("error");
          setMessageHeader("Error!");
          setIsMessageOpen(true);
        }
      });
  };
  // const archiveCredits = () => {
  //   setLoading(true);
  //   axios
  //     .post("/card/archive", {
  //       student_id: currentUser.id,
  //       card_id: selectedCard?.id,
  //       semester_name: semesterContext.selectedSemester?.label,
  //     })
  //     .then((res) => {
  //       setLoading(false);
  //       setConfirmArchive(false);
  //       setMessage("Card archived successfully");
  //       if (res.data.card) {
  //         setMessageType("success");
  //         setMessageHeader("Success!");
  //         fetchCredits(currentUser.id);
  //       } else {
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //       }
  //       setIsMessageOpen(true);
  //       setConfirmDelete(false);
  //     })
  //     .catch(function (error) {
  //       if (error.response) {
  //         setLoading(false);
  //         setMessage(error.response.data.error || "Something went wrong!");
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //         setIsMessageOpen(true);
  //       }
  //     });
  // };
  const deleteCredits = () => {
    setLoading(true);
    axios
      .delete(
        `/card/delete?student_id=${currentUser.id}&card_id=${selectedCard?.id}`
      )
      .then((res) => {
        setLoading(false);
        setConfirmDelete(false);
        setMessage(res.data.success);
        if (res.data.success) {
          setMessageType("success");
          setMessageHeader("Success!");
          fetchCredits(currentUser.id);
        } else {
          setMessageType("error");
          setMessageHeader("Error!");
        }
        setIsMessageOpen(true);
        setConfirmDelete(false);
      })
      .catch(function (error) {
        handleJWTError(error);
        if (error.response) {
          setLoading(false);
          setMessage(error.response.data.error || "Something went wrong!");
          setMessageType("error");
          setMessageHeader("Error!");
          setIsMessageOpen(true);
        }
      });
  };

  const fetchCompetencyEvaluation = () => {
    setIsMessageOpen(false);
    axios
      .get(
        `/student/competencyevaluation?student_id=${currentUser.id}&semester_id=${semesterContext.selectedSemester?.id}`
      )
      .then((res) => {
        if (res.data) {
          setEvaluationData(res.data?.competency_evaluation);
          // setTimeout(() => {
          if (
            compareTwoDates(
              new Date(),
              new Date(semesterContext.selectedSemester?.end_date)
            )
          ) {
            if (
              // isTodayBetweenDeadlines() &&
              compareTwoDates(
                new Date(),
                new Date(
                  semesterContext.selectedSemester?.instructor_grading_deadline
                )
              )
            ) {
              setMessageHeader("Info");
              setMessageType("info");
              setMessage(
                "All instructors should have submitted assessment grades. If you believe you have completed a competency but it does not display a mastery level, contact the AiCE program staff"
              );
              setIsMessageOpen(true);
            } else {
              setMessageHeader("Info");
              setMessageType("info");
              setMessage(
                `Competency recording deadline for "${semesterContext.selectedSemester?.semester_name}" has passed. Recording is not permitted.`
              );
              setIsMessageOpen(true);
            }
          } else if (
            // isTodayBetweenDeadlines() &&
            compareTwoDates(
              new Date(),
              new Date(
                semesterContext.selectedSemester?.instructor_grading_deadline
              )
            )
          ) {
            setMessageHeader("Info");
            setMessageType("info");
            setMessage(
              "All instructors should have submitted assessment grades. If you believe you have completed a competency but it does not display a mastery level, contact the AiCE program staff"
            );
            setIsMessageOpen(true);
          } else if (!res.data?.competency_evaluation.all_completed) {
            setMessageHeader("Info");
            setMessageType("info");
            setMessage(
              "You must complete evaluations for all your competencies before you can record them."
            );
            setIsMessageOpen(true);
          }
        }
        else {
          setEvaluationData([]);
        }
      })
      .catch((err) => {
        setEvaluationData([]);
        handleJWTError(err);
        if (
          compareTwoDates(
            new Date(),
            new Date(semesterContext.selectedSemester?.end_date)
          )
        ) {
          if (
            // isTodayBetweenDeadlines() &&
            compareTwoDates(
              new Date(),
              new Date(
                semesterContext.selectedSemester?.instructor_grading_deadline
              )
            )
          ) {
            setMessageHeader("Info");
            setMessageType("info");
            setMessage(
              "All instructors should have submitted assessment grades. If you believe you have completed a competency but it does not display a mastery level, contact the AiCE program staff"
            );
            setIsMessageOpen(true);
          }
          if (
            // isTodayBetweenDeadlines() &&
            compareTwoDates(
              new Date(),
              new Date(
                semesterContext.selectedSemester?.instructor_grading_deadline
              )
            )
          ) {
            setMessageHeader("Info");
            setMessageType("info");
            setMessage(
              "All instructors should have submitted assessment grades. If you believe you have completed a competency but it does not display a mastery level, contact the AiCE program staff"
            );
            setIsMessageOpen(true);
          } else {
            setMessageHeader("Info");
            setMessageType("info");
            setMessage(
              `Competency recording deadline for "${semesterContext.selectedSemester?.semester_name}" has passed. Recording is not permitted.`
            );
            setIsMessageOpen(true);
          }
        }
      });
  };
  const getSemester = (index: number) => {
    if (index + 1 > semesterContext.semesters.length) {
      return semesterContext.selectedSemester;
    }
    return semesterContext.semesters[index];
  };
  const selectedSemesterIndex = semesterContext.semesters.findIndex(
    (el: any) => el.label === semesterContext.selectedSemester?.label
  );
  const hasNextSemester =
    selectedSemesterIndex >= 0 &&
    selectedSemesterIndex + 1 < semesterContext.semesters.length;
  // const extendCredits = () => {
  //   setLoading(true);
  //   const semesterIndex = semesterContext.semesters.findIndex((el) => {
  //     return el.label === semesterContext.selectedSemester?.label;
  //   });
  //   axios
  //     .post("/card/extend", {
  //       student_id: currentUser.id,
  //       card_id: selectedCard?.id,
  //       semester_name: getSemester(semesterIndex + 1).label,
  //     })
  //     .then((res) => {
  //       setLoading(false);
  //       setConfirmExtend(false);
  //       setMessage("Extended card successfully");
  //       if (res.data.card) {
  //         setMessageType("success");
  //         setMessageHeader("Success!");
  //         fetchCredits(currentUser.id);
  //       } else {
  //         setMessage("Error on Extending card");
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //       }
  //       setIsMessageOpen(true);
  //       setConfirmDelete(false);
  //     })
  //     .catch(function (error) {
  //       if (error.response) {
  //         setLoading(false);
  //         setMessage(error.response.data.error || "Something went wrong!");
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //         setIsMessageOpen(true);
  //       }
  //     });
  // };
  const openRecordModal = (data: any) => {
    if (data) {
      setSelectedCard(data);
      setConfirm(true);
    }
  };
  const openDeleteModal = (data: any) => {
    if (data) {
      setSelectedCard(data);
      setConfirmDelete(true);
    }
  };
  // const openArchiveModal = (data: any) => {
  //   if (data) {
  //     setSelectedCard(data);
  //     setConfirmArchive(true);
  //   }
  // };

  const CreditStyle = styled("div")`
    padding: 10px 5px;
    display: flex;
    justify-content: start;
    align-items: center;
    color: #2fff00;
  `;

  // Drop Course Modal
  const openExtendModal = (course: any) => {
    setSelectedCard(course);
    if (!hasNextSemester) {
      setIsNoNextSemesterOpen(true);
      return;
    }
    setConfirmExtend(true);
  };

  function compareTwoDates(first: Date, second: Date) {
    return moment(first).isAfter(second);
  }
  const isTodayBetweenDeadlines = () => {
    const today = moment();
    const gradingDeadline = moment(
      semesterContext.selectedSemester?.instructor_grading_deadline
    );
    const recordingDeadline = moment(
      semesterContext.selectedSemester?.competency_recording_deadline
    );
    return today.isBetween(gradingDeadline, recordingDeadline, undefined, "[]");
  };
  if (!enrolled) {
    return (
      <FlexGrow style={{ textAlign: "center", paddingTop: "30px" }}>
        <StyledText color="red" fontWeight="700" textSize={TextSize.default}>
          Student not enrolled for {semesterContext.selectedSemester?.label}
        </StyledText>
      </FlexGrow>
    );
  }

  return (
    <>
      <EvaluateModal
        fetchCompetencyEvaluation={fetchCompetencyEvaluation}
        studentId={currentUser.id}
        semester={semesterContext.selectedSemester}
        title="Competency Evaluation Form"
        setOpen={setIsEvaluateOpen}
        isOpen={isEvaluteOpen}
        confirmFunction={() => {
          recordCredits();
        }}
        evaluationData={evaluationData}
        message={message}
        setMessage={setMessage}
        isSnackbarOpen={isMessageOpen}
        setIsSnackbarOpen={setIsMessageOpen}
        messageType={messageType}
        setMessageType={setMessageType}
        messageHeader={messageHeader}
        setMessageHeader={setMessageHeader}
      />
      <ViewDetailModal
        credits={credits}
        title="Skills"
        isOpen={isDetailOpen}
        setOpen={setIsDetailOpen}
        selectedRow={selectedRow}
      />
      <ConfirmModal
        title="Record Competency"
        description="Are you sure you want to record this competency?"
        setOpen={setConfirm}
        isOpen={confirm}
        confirmFunction={() => {
          recordCredits();
        }}
      />
      {/* <ConfirmModal
        title="Extend Competency"
        description="Are you sure you want to extend this competency?"
        setOpen={setConfirmExtend}
        isOpen={confirmExtend}
        confirmFunction={() => {
          extendCredits();
        }}
      />
      <ConfirmModal
        title="Extend Competency"
        description="No semester available for extension, please contact the admin for assistance"
        isOpen={isNoNextSemesterOpen}
        setOpen={setIsNoNextSemesterOpen}
        hideCancel
        confirmLabel="Ok"
        confirmFunction={() => setIsNoNextSemesterOpen(false)}
      /> */}
      <ConfirmModal
        title="Delete Competency"
        description="Are you sure you want to delete this competency?"
        setOpen={setConfirmDelete}
        isOpen={confirmDelete}
        confirmFunction={() => {
          deleteCredits();
        }}
      />
      {/* <ConfirmModal
        title="Archive Competency"
        description="Are you sure you want to archive this competency?"
        setOpen={setConfirmArchive}
        isOpen={confirmArchive}
        confirmFunction={() => {
          archiveCredits();
        }}
      /> */}
      <SnackBar
        isOpen={isMessageOpen}
        setOpen={setIsMessageOpen}
        header={messageHeader}
        message={message}
        type={messageType}
        style={{
          bottom: `${
            globalSnackCount > 0 ? 30 + globalSnackCount * 120 : 10
          }px`,
        }}
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <CreditStyle>
          My Credits{" "}
          <div
            style={{
              border: "1px solid #86868636",
              marginLeft: 10,
              color: "white",
              padding: "5px 10px",
              borderRadius: 5,
            }}
          >
            Total : {totalCredits}, Recorded : {totalRecordedCredits}{" "}
          </div>
        </CreditStyle>
        {semesterContext.selectedSemester?.is_open && (
          <Button
            onClick={() => {
              setIsEvaluateOpen(true);
            }}
            style={{
              padding: "7px",
              position: isMobile ? "relative" : "absolute",
              top: isMobile ? 0 : -41,
              right: isMobile ? 0 : 88,
              alignSelf: "center",
              width: 250,
              zIndex: isMobile ? 1 : 999,
              // height: 40,
            }}
            status={Status.button}
            isFullwidth
          >
            Evaluate Competencies
          </Button>
        )}
      </div>
      <CustomRow
        wrap="nowrap"
        style={{ marginLeft: "-12px", marginRight: "-10px", maxHeight: "80vh" }}
      >
        <Col style={{ padding: 0 }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <TableComponent height="85vh" aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        fontWeight: "bold",
                        borderBottom: "1px solid #3C406C",
                      }}
                    >
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {credits.length === 0 ? (
                  <>
                    <StyledTableRow role="checkbox" tabIndex={-1} key={0}>
                      <StyledTableCell colSpan={6} key={1} align="center">
                        No competencies found for the selected semester
                      </StyledTableCell>
                    </StyledTableRow>
                  </>
                ) : (
                  <>
                    {credits.map((row, index) => {
                      if (!row.competency_code.includes("SOF"))
                        return (
                          <StyledTableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            {columns.map((column: Column) => {
                              const value = row[column.id];
                              if (column.id === "action") {
                                if (
                                  evaluationData.all_completed &&
                                  isExceedFinalAssessmentDate &&
                                  semesterContext.selectedSemester?.is_open
                                ) {
                                  return (
                                    <StyledTableCell
                                      key={column.id}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                      align={column.align}
                                    >
                                      <CreditsDropdown
                                        credit={row}
                                        openRecordModal={openRecordModal}
                                        openExtendModal={openExtendModal}
                                        openDeleteModal={openDeleteModal}
                                      // openArchiveModal={openArchiveModal}
                                      />
                                    </StyledTableCell>
                                  );
                                }
                              }
                              if (column.id === "detail") {
                                return (
                                  <StyledTableCell
                                    key={column.id}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    align={column.align}
                                  >
                                    <Button
                                      onClick={() => {
                                        setIsDetailOpen(true);
                                        setSelectedRow(row);
                                      }}
                                      style={{
                                        padding: "7px",

                                        alignSelf: "center",
                                        // width: 20,
                                        zIndex: isMobile ? 1 : 999,
                                        // height: 40,
                                      }}
                                      status={Status.blue}
                                      isFullwidth
                                    >
                                      Details
                                    </Button>
                                  </StyledTableCell>
                                );
                              }
                              if (column.id === "assessed_skills") {
                                if (row.transferred === true) {
                                  return (
                                    <StyledTableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      Transferred
                                    </StyledTableCell>
                                  );
                                }
                                return (
                                  <StyledTableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {value}
                                  </StyledTableCell>
                                );
                              }
                              if (column.id === "status") {
                                if (row.status === "Recorded") {
                                  return (
                                    <StyledTableCell
                                      style={{ color: "green" }}
                                      key={column.id}
                                      align={column.align}
                                    >
                                      Recorded
                                    </StyledTableCell>
                                  );
                                }
                                return (
                                  <StyledTableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {value}
                                  </StyledTableCell>
                                );
                              }
                              if (column.id === "provides_credit") {
                                if (!row.transferred) {
                                  return (
                                    <StyledTableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      --
                                    </StyledTableCell>
                                  );
                                } else
                                  return (
                                    <StyledTableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {row.provides_credit ? (
                                        <Icon
                                          fixedWidth={false}
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            color: "#0cff0c",
                                          }}
                                          size={3}
                                          mr={1}
                                          name="check"
                                        />
                                      ) : (
                                        <Icon
                                          // fixedWidth={false}
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            color: "red",
                                          }}
                                          size={3}
                                          mr={1}
                                          name="times"
                                        />
                                      )}
                                    </StyledTableCell>
                                  );
                              }
                              return (
                                <StyledTableCell
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </StyledTableCell>
                              );
                            })}
                          </StyledTableRow>
                        );
                    })}
                  </>
                )}
              </TableBody>
            </TableComponent>
          )}
        </Col>
      </CustomRow>
    </>
  );
}
export default StudentCreditsPage;
